import { mapGetters, mapActions } from 'vuex'
import { plainToClass } from 'class-transformer'
import Theme from '@/models/theme'
import Pairing from '@/models/pairing'
import Schedule from '@/models/schedule'
import Response from '@/utils/response'
import { storageCache } from '@/utils/storage-cache'
import mPageLoading from '@/mixins/page-loading'
import mPageTitle from '@/mixins/page-title'
import BtnIcon from '@/components/button/BtnIcon'
import PairingRow from '@/components/card/PairingRow'
import ThemeScheduleRow from '@/components/card/ThemeScheduleRow'

export default {
  components: {
    BtnIcon,
    PairingRow,
    ThemeScheduleRow
  },
  mixins: [
    mPageLoading,
    mPageTitle
  ],
  title () {
    return this.$t("text.imageDiagnosis")
  },
  props: {
    repository: Object,
    pairingsRepository: Object
  },
  data () {
    return {
      officialThemeSchedules: [],
      themeSchedules: [],
      pairings: []
    }
  },
  computed: {
    themeEmptyAll () {
      return this.officialThemeSchedules.length === 0 &&
        this.themeSchedules.length === 0 &&
        this.pairings.length === 0
    },
  },
  mounted () {
    this.clearToolbarTitle()
    this.resetBackRoute()
    this.fetchData()
    storageCache.clearExpiredAll()
  },
  methods: {
    ...mapActions([
      'clearToolbarTitle',
      'resetBackRoute',
    ]),
    ...mapActions([
      'checkPublishingCounts'
    ]),
    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.get())
        this.officialThemeSchedules = plainToClass(Schedule, response.result.official_theme_schedules)
        this.themeSchedules = plainToClass(Schedule, response.result.theme_schedules)
        this.checkPublishingCounts()
        this.fetchPairings()
      } catch (error) {
        this.$store.commit('setAxiosError', error)
        this.loading = false
      }
    },
    async fetchPairings () {
      try {
        const response = new Response(await this.pairingsRepository.get())
        this.pairings = plainToClass(Pairing, response.result)
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    onAnswer (object) {
      this.$router.push({
        name: 'themeSchedule-answer',
        params: { id: object.id }
      })
    },
    onResult (object) {
      this.$router.push({
        name: 'answer-show',
        params: { id: object.id }
      })
    },
    onHistory (theme) {
      this.$router.push({
        name: 'answer-index',
        params: { theme_id: theme.id }
      })
    },
    tabNext () {
      this.$router.push({ name: "matching-index" })
    },
    onPairingAnswer (pairingsThemesUser) {
      this.$router.push({
        name: 'pairings-answer',
        query: { target_id: pairingsThemesUser.id }
      })
    },
    onPairingResult (pairingsThemesUser) {
      this.$router.push({
        name: 'answer-show',
        params: { id: pairingsThemesUser.answer.id },
        query: { from: this.fullPath }
      })
    },
    onPairingSummary (pairing) {
      this.$router.push({
        name: 'pairing-show',
        params: { id: pairing.id },
        query: { from: this.fullPath }
      })
    }
  }
}
